/**
 * Labstep
 *
 * @module components/ProtocolTimer/Notifier
 * @desc A component to notify user when alert is running low (under 10s)
 */

import { ProtocolTimerAlert } from 'labstep-web/components/ProtocolTimer/Alert';
import { ProtocolTimerItemContainer } from 'labstep-web/containers/ProtocolTimer/Item';
import type React from 'react';
import type { IProtocolAlertTimerProps } from './types';

export const ProtocolAlertTimer: React.FC<
  IProtocolAlertTimerProps
> = ({ protocol }) => (
  <>
    {protocol.protocol_timers.map((protocolTimer) => (
      <ProtocolTimerItemContainer
        key={protocolTimer.guid}
        protocolTimer={protocolTimer}
      >
        {({ timeRemaining }) => (
          <ProtocolTimerAlert
            protocolTimer={protocolTimer}
            protocol={protocol}
            timeRemaining={timeRemaining}
          />
        )}
      </ProtocolTimerItemContainer>
    ))}
  </>
);
